<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content common-search-formtype">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="标题:">
              <el-input v-model.trim="formInlineTmp.title" placeholder="请输入标题模糊查询" type="text" style="line-height: 60px;" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right" style="">
        <el-button type="primary" @click="addDialog = true" class="add-btn" style="float: right;margin-right: 32px;">添加</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData" v-loading="loading" class="table">
        <el-table-column label="ID" align="center" width="100">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column label="标题">
          <template slot-scope="scope">
            {{ scope.row.title }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="200">
          <template slot-scope="scope">
            {{ scope.row.create_time_text }}
          </template>
        </el-table-column>
        <el-table-column label="修改时间" width="200">
          <template slot-scope="scope">
            {{ scope.row.update_time_text }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <div class="op-link" @click="editAction(scope.row.id)">
              编辑
            </div>
            <div class="op-link" @click="deleteAction(scope.row.id)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>

      <el-dialog class="cellDialog base-dialog" title="添加帮助信息" :visible.sync="addDialog" width="550px">
        <el-form :model="addForm" label-width="110px" ref="addForm" :rules="rules">
          <el-form-item label="标题" prop="title">
            <el-input v-model="addForm.title" placeholder="请输入标题" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="content" class="height-textarea" style="height: 100px;">
            <el-input v-model="addForm.content" :autosize="{ minRows: 5, maxRows: 5}" placeholder="请输入内容" type="textarea" maxlength="200"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="dialog-cancel-btn" @click="closeAddDialogAction">取 消</el-button>
          <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitForm('addForm')">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog class="cellDialog base-dialog" title="修改帮助信息" :visible.sync="editDialog" width="550px">
        <el-form :model="editForm" label-width="110px"  ref="editForm" :rules="rules" >
          <el-form-item label="标题" prop="title">
            <el-input v-model="editForm.title" placeholder="请输入标题" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="content" class="height-textarea" style="height: 100px;">
            <el-input v-model="editForm.content" :autosize="{ minRows: 5, maxRows: 5}" placeholder="请输入内容" type="textarea" maxlength="2000"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="dialog-cancel-btn" @click="editDialog = false">取 消</el-button>
          <el-button class="dialog-confirm-btn" style="margin-right: 32px" type="primary" @click="submitconfirmForm('editForm')">确 定</el-button>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import { getYxQa, deleteYxQa, createYxQa, getYxQaDetail, editYxQa } from '@/api/yunxiao.js'
export default {
  name: 'list',
  data () {
    return {
      loading: true,
      formInlineTmp:{},
      formInline: {
        title:'',
      },
      options: [],
      hide: true,
      tableData: [],
      page: 1,
      totalCount: 0,
      limit: 10,
      addForm: {
        title: '',
        content: ''
      },
      editForm: {
        title: '',
        content: ''
      },
      editId: '',
      editDialog: false,
      addDialog: false,
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    searchLoad() {
      this.page = 1
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    getData() {
      this.loading = true
      getYxQa(this.page, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.count
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    closeAddDialogAction() {
      this.addDialog = false
      this.resetForm()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addAction()
        } else {
          return false
        }
      })
    },
    // 请求详情
    editAction(id) {
      this.editDialog = true
      this.editId = id
      getYxQaDetail(id).then(res => {
        this.editForm = res.data.data
      })
    },
    submitconfirmForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmAction()
        } else {
          return false
        }
      })
    },
    // 修改
    confirmAction() {
      editYxQa(this.editId, this.editForm).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          this.editDialog = false
          this.getData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 添加
    addAction() {
      createYxQa(this.addForm).then(res => {
        if (res.data.code === 0) {
          this.addDialog = false
          _g.toastMsg('success', res.data.error)
          this.getData()
          this.resetForm()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    resetForm() {
      this.addForm = {
        title: '',
        content: ''
      }
    },
    // 删除
    deleteAction(id) {
      this.$confirm('确认删除该信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteYxQa(id).then((res) => {
          if (res.data.code === 0) {
            this.getData()
            _g.toastMsg('success', '删除成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  created() {
    this.getData()
  },
  components: {
  }
}
</script>

<style scoped>

</style>
